import React, { createContext, useState } from "react";
import IndexServices from "../services/IndexServices";
import Cookies from "js-cookie";
import Loader from "../general_components/Loader";
import SuccessMessage from "../general_components/SuccessMessage";
import ErrorMessage from "../general_components/ErrorMessage";
import { convertFromRaw, EditorState } from "draft-js";

export const ProjectContext = createContext();

export default function ProjectContextProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [show, setShow] = useState(false);
  const [id, setId] = useState("");
  const [openDel, setOpenDel] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(true);
  const [load, setLoad] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [projectCategory, setProjectCategory] = useState("");
  const storedRole = Cookies.get("role");

  // project
  const [selectedProjectId, setselectedProjectId] = useState(null);
  const [selectedProject, setselectedProject] = useState(null);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [projectLoaction, setProjectLoaction] = useState("");
  const [projectTypology, setProjectTypology] = useState("");
  const [projectDescription, setProjectDescription] = useState("");
  const [projectArea, setProjectArea] = useState("");
  const [projectStatus, setProjectStatus] = useState("");
  const [projectSubCategory, setProjectSubCategory] = useState("");
  const [projectDate, setProjectDate] = useState("");
  const [allProject, setAllProject] = useState([]);

  // images
  const [cardImage, setCardImage] = useState(null);
  const [cardRawImage, setCardRawImage] = useState(null);
  const [fullRawImage, setFullRawImage] = useState(null);
  const [fullImage, setFullImage] = useState(null);
  const [projectGallaryImages, setProjectGallaryImages] = useState([]);
  const [projectGallaryRawImages, setprojectGallaryRawImages] = useState([]);

  // category
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([
    "ARCHITECTURE",
    "INTERIOR",
  ]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryId, setCategoryId] = useState("");
  // move
  const [previousCategory, setPreviousCategory] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);

  // other
  const handleOpen = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    handleEmpty();
  };
  const handleOpenShow = () => {
    setShow(true);
    setLoading(false);
  };

  const handleCloseShow = () => {
    setShow(false);
    setCategoryName("")
  };

  // fetch Category
  const fetchCategory = async () => {
    try {
      const response = await IndexServices.getCategory();
      setCategoryList(response?.data?.data);
    } catch (error) {
      setError(true);
      setErrorMessage("Something Went Wrong");
    }
  };

  // add category
  const handleAddCategory = async (newCategory) => {
    await IndexServices.addCategory(newCategory)
      .then((response) => {
        if (response.data.success) {
          setCategoryList(response?.data?.data);
          fetchCategory();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
          setError(true);
          setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    setCategoryName("");
    setShow(false);
  };

  // projects
  // fetch projects
  const fetchProjects = async () => {
    try {
      const response = await IndexServices.getProject();
      setAllProject(response?.data?.data);
    } catch (error) {
      setError(true);
      setErrorMessage("Something Went Wrong");
    }
  };
  const onAddProducts = () => {
    setOpenModal(true);
  };

  // add project
  const handleAddProject = async (newProject) => {
    setOpen(true);
    setLoading(true);
    const formData = new FormData();
    formData.append("title", newProject.companyName);
    formData.append("date", newProject.projectDate);
    formData.append("area", newProject.projectArea);
    formData.append("location", newProject.projectLoaction);
    formData.append("subCategory", newProject.projectSubCategory);
    formData.append("status", newProject.projectStatus);
    formData.append("description", newProject.projectDescription);
    formData.append("cardImage", newProject.cardImage);
    formData.append("fullImage", newProject.fullImage);
    // formData.append("team", JSON.stringify(newProject.team));
    newProject.projectGallaryImages.forEach((item, index) => {
      formData.append(`galleryImages[${index}]`, item.file);
    });
    formData.append("typology", newProject.projectTypology);

    newProject.projectGallaryImages.forEach((item, index) => {
      console.log(formData.get(`galleryImages[${index}]`));
    });

    await IndexServices.addProject(formData, categoryId)
      .then((response) => {
        if (response.data.success) {
          setAllProject(response?.data?.data);
          fetchProjects();
          fetchCategory();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
          setError(true);
          setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    handleEmpty();
  };

  const handleEmpty = () => {
    setCompanyName("");
    setProjectArea("");
    setProjectDescription("");
    setProjectLoaction("");
    setProjectTypology("");
    setProjectDate("");
    setProjectStatus("");
    setProjectDate("");
    setProjectSubCategory("");
    setCardImage(null);
    setCardRawImage(null);
    setFullRawImage(null);
    setFullImage(null);
    setProjectGallaryImages([]);
    setprojectGallaryRawImages([]);
  };

  const handleFillData = (data) => {
    setCompanyName(data.title);
    setProjectArea(data.area);
    setProjectDescription(
      !data.description
        ? EditorState.createEmpty()
        : EditorState.createWithContent(convertFromRaw(JSON.parse(data.description)))
    );
    setProjectLoaction(data.location);
    setProjectTypology(data.typology);
    setProjectDate(data.date);
    setProjectStatus(data.status);
    setProjectSubCategory(data.subCategory);
    setCardImage(data.cardImage);
    setCardRawImage(data.galleryImages);
    setFullRawImage(data.galleryImages[0]);
    setFullImage(data.galleryImages[0]);
    setProjectGallaryImages(data.galleryImages);
    setprojectGallaryRawImages(data.galleryImages);
  };

  // edit project
  const handleEditProject = async (updatedProjectData, Id, oldProjectData) => {
    setOpen(true);
    setLoading(true);
    const formData = new FormData();
    if (
      updatedProjectData.companyName !== oldProjectData.companyName ||
      updatedProjectData.companyName !== ""
    ) {
      formData.append("title", updatedProjectData.companyName);
    }
    if (
      updatedProjectData.projectDate !== oldProjectData.projectDate ||
      updatedProjectData.projectDate !== ""
    ) {
      formData.append("date", updatedProjectData.projectDate);
    }
    if (
      updatedProjectData.projectArea !== oldProjectData.projectArea ||
      updatedProjectData.projectArea !== ""
    ) {
      formData.append("area", updatedProjectData.projectArea);
    }
    if (
      updatedProjectData.projectLoaction !== oldProjectData.projectLoaction ||
      updatedProjectData.projectLoaction !== ""
    ) {
      formData.append("location", updatedProjectData.projectLoaction);
    }
    if (
      updatedProjectData.projectSubCategory !==
        oldProjectData.projectSubCategory ||
      updatedProjectData.projectSubCategory !== ""
    ) {
      formData.append("subCategory", updatedProjectData.projectSubCategory);
    }
    if (
      updatedProjectData.projectStatus !== oldProjectData.projectStatus ||
      updatedProjectData.projectStatus !== ""
    ) {
      formData.append("status", updatedProjectData.projectStatus);
    }
    if (
      updatedProjectData.projectDescription !==
        oldProjectData.projectDescription ||
      updatedProjectData.projectDescription !== ""
    ) {
      formData.append("description", updatedProjectData.projectDescription);
    }
    if (updatedProjectData.cardImage) {
      formData.append("cardImage", updatedProjectData.cardImage);
    }
    if (updatedProjectData.fullImage) {
      formData.append("fullImage", updatedProjectData.fullImage);
    }
    if (updatedProjectData.projectGallaryImages.length > 0) {
      updatedProjectData.projectGallaryImages.forEach((galleryImage, index) => {
        formData.append(`galleryImages[${index}]`, galleryImage);
      });
    }
    if (
      updatedProjectData.projectTypology !== oldProjectData.projectTypology ||
      updatedProjectData.projectTypology !== ""
    ) {
      formData.append("typology", updatedProjectData.projectTypology);
    }
    await IndexServices.editProject(Id, formData)
      .then((response) => {
        if (response.data.success) {
          setAllProject(response?.data?.data);
          fetchProjects();
          fetchCategory();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
          setError(true);
          setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    setCompanyName("");
    setProjectArea("");
    setProjectDescription("");
    setProjectLoaction("");
    setProjectTypology("");
    setProjectDate("");
    setProjectStatus("");
    setProjectDate("");
  };
  // delete project
  const handleDeleteProject = async () => {
    setOpen(true);
    setLoading(true);
    await IndexServices.deleteProject(id, storedRole, categoryId)
      .then((response) => {
        if (response.data.success) {
          fetchProjects();
          fetchCategory();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
          setError(true);
          setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    setId("");
    setCategoryId("");
  };

  // move project
  const handleMoveProject = async (data) => {
    const projectId = data.projectId;
    const previousCategory = data.previousCategory.categoryId;
    const currentCategory = data.currentCategory.categoryId;
    setOpen(true);
    setLoading(true);
    await IndexServices.moveProject(
      projectId,
      storedRole,
      previousCategory,
      currentCategory
    )
      .then((response) => {
        if (response.data.success) {
          fetchProjects();
          fetchCategory();
          setOpen(false);
          setConfirm(true);
          setTimeout(() => {
            setConfirm(false);
          }, 2000);
        } else {
          setError(true);
          setErrorMessage("Something Went Wrong");
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
        setErrorMessage("Something Went Wrong");
      });
    setId("");
    setCategoryId("");
  };

  // selected project
  const handleSelectedProject = (ProjectId) => {
    const selectedProject = allProject.find(
      (project) => project.projectId === ProjectId
    );
    setselectedProject(selectedProject);
  };

  return (
    <ProjectContext.Provider
      value={{
        handleAddProject,
        handleDeleteProject,
        handleEditProject,
        openModal,
        setOpenModal,
        companyName,
        setCompanyName,
        projectLoaction,
        setProjectLoaction,
        projectTypology,
        setProjectTypology,
        projectDescription,
        setProjectDescription,
        projectArea,
        fetchCategory,
        setProjectArea,
        projectStatus,
        setProjectStatus,
        projectDate,
        setProjectDate,
        allProject,
        projectGallaryImages,
        setProjectGallaryImages,
        projectGallaryRawImages,
        setprojectGallaryRawImages,
        selectedProject,
        setselectedProject,
        selectedProjectId,
        setselectedProjectId,
        handleSelectedProject,
        categoryList,
        subCategoryList,
        handleOpen,
        handleClose,
        setCategoryList,
        setSubCategoryList,
        handleAddCategory,
        categoryName,
        setCategoryName,
        show,
        setShow,
        handleOpenShow,
        handleCloseShow,
        projectSubCategory,
        setProjectSubCategory,
        cardImage,
        setCardImage,
        fullImage,
        setFullImage,
        cardRawImage,
        setCardRawImage,
        fullRawImage,
        setFullRawImage,
        onAddProducts,
        setCategoryId,
        fetchProjects,
        handleFillData,
        handleEmpty,
        editMode,
        setEditMode,
        id,
        setId,
        openDel,
        setOpenDel,
        load,
        setLoad,
        projectCategory,
        setProjectCategory,
        loading,
        previousCategory,
        setPreviousCategory,
        currentCategory,
        setCurrentCategory,
        selectedTeam,
        setSelectedTeam,
        handleMoveProject,
        setLoading,
      }}
    >
      {children}
      <Loader open={open} close={setOpen} />
      <SuccessMessage open={confirm} close={setConfirm} />
      <ErrorMessage open={error} close={setError} message={errorMessage} />
    </ProjectContext.Provider>
  );
}
